import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class VehicleInspection extends AbstractModel {
  @autoserialize
  vehicleId: number;

  @autoserialize
  interiorInspectionNotes: string;

  @autoserialize
  exteriorInspectionNotes: string;

  @autoserialize
  allItemsPassed: boolean;

  @autoserialize
  createdByUserId: number;
}
